import { AsyncGridColumns, ColumnLink } from '~/shared/ui/AsyncGrid'
import { ChipStatus } from '~/shared/ui/Chips'
import { formingLink } from './lib'
import { GridRow } from './types'

export const columns: AsyncGridColumns<GridRow> = [
  {
    headerName: 'column.account',
    field: 'title',
    sortable: false,
    flex: 1,
    minWidth: 300,
    renderCell: ({ row }) => (
      <ColumnLink to={formingLink(row.aggregatorCode, row.id)}>
        {row.title}
      </ColumnLink>
    ),
  },
  {
    headerName: 'column.aggregator',
    field: 'aggregatorCode',
    sortable: false,
    flex: 1,
  },
  {
    headerName: 'column.driver id in aggregator',
    field: 'extId',
    sortable: false,
    flex: 1,
  },
  {
    headerName: 'column.primary',
    field: 'mainAccount',
    sortable: false,
    flex: 1,
    renderCell: ({ value }) => (
      <ChipStatus
        labelI18n={value ? 'button.yes' : 'button.no'}
        variant={value ? 'green' : 'gray'}
      />
    ),
  },
  {
    headerName: 'column.employment type',
    field: 'aggregatorOccupationTitle',
    sortable: false,
    flex: 1,
  },
  {
    headerName: 'column.working conditions',
    field: 'yandexWorkRule',
    sortable: false,
    flex: 1,
  },
]
